<template>
  <!-- scanEntry >>> 身份验证 by lbj-->
  <div class="page"
       :style="{background: 'url(/img/bg.png) no-repeat',backgroundSize: '100% 100%'}">
    <div v-show="loading"
         class="loading">
      <van-loading type="spinner"
                   color="#1989fa" />
    </div>
    <div class="register_title">登陆验证</div>
    <div v-if="showLogincont">
      <div class="input_box">
        <div class="icon">
          <!-- <img src="src/assets/img/login.png"
          alt="">-->
          <!-- <svg-icon icon-class="login"></svg-icon> -->
        </div>
        <div class="input_box_xia"
             v-show="mode">
          <!-- <el-input v-model="tel"
                  type="tel"
          placeholder="手机号码" />-->
          <van-field v-model="tel"
                     type="tel"
                     label="手机号"
                     maxlength="11"
                     placeholder="手机号码"
                     :error-message="errMsg" />
        </div>
        <div class="input_box_xia"
             v-show="mode && (show_sms_code ==1 || show_sms_code=='1')">
          <!-- <el-input v-model="code"
                  type="tel"
                  placeholder="验证码" />
        <div class="code_gain"
             v-if="!showGetCode || countDown !== 0">{{ countDown === 0 ? "获取验证码" : `${countDown}秒重新获取` }}</div>
        <div class="code_gain code_gain-on bton"
             v-if="showGetCode && countDown === 0"
          @click="getCode">获取验证码</div>-->
          <van-field v-model="code"
                     center
                     clearable
                     type="tel"
                     label="短信验证码"
                     placeholder="请输入验证码">
            <template #button>
              <van-button size="small"
                          type="primary"
                          disabled
                          v-if="!showGetCode || countDown !== 0">{{ countDown === 0 ? "获取验证码" : `${countDown}秒重新获取` }}</van-button>
              <van-button size="small"
                          type="primary"
                          v-if="showGetCode && countDown === 0"
                          @click="getCode">获取验证码</van-button>
            </template>
          </van-field>
        </div>
        <div class="input_box_xia"
             v-show="!mode">
          <!-- <el-input v-model="sfz"
                  type="tel"
          placeholder="身份证号码" />-->
          <van-field v-model="sfz"
                     placeholder="身份证号码"
                     readonly
                     clickable
                     @touchstart.stop="showKeyboard = true" />
          <van-number-keyboard :show="showKeyboard"
                               v-model="sfz"
                               extra-key="X"
                               close-button-text="完成"
                               @blur="KeyboardBlur" />
          <!-- @input="onInput"
          @delete="onDelete"-->
        </div>
      </div>
      <div class="dragVerify"
           v-if="UseSlideCheck == 1">
        <drag-verify ref="dragVerify"
                     class="drag"
                     :width="drag_width"
                     :height="drag_height"
                     :isPassing.sync="isPassing2"
                     text="请按住滑块拖动"
                     successText="验证通过"
                     handlerIcon="fa fa-angle-double-right"
                     successIcon="fa fa-check"
                     @passcallback="pass">
          <i v-show="!isPassing2"
             slot="textBefore"
             class="fa fa-lock"></i>
        </drag-verify>
      </div>

      <div :class="`Sed bton ${canSubmit ? 'op' : ''}`"
           @click="check">确认</div>
      <div class="footer2"
           v-if="show_user_agreement == 1"
           v-show="useagree">
        <van-checkbox v-model="agree"
                      icon-size="20px"
                      label-disabled>
          我已阅读并同意
          <span @click="showPrivacyPop=true">{{`《${user_agreement_title} 》`}}</span>
          <!-- <span @click="showag=true">《用户数据采集安全协议说明》</span> -->
        </van-checkbox>
        <van-popup round
                   :closeable="true"
                   v-model="showag">
          <showAgreeMemo :agreememo="agreememo" />
        </van-popup>
      </div>
      <div class="footer"
           @click="changeMode"
           id="footer"
           v-show="showFooter">
        <span>{{ mode ? "切换身份证登陆" : "切换手机号登陆" }}</span>
      </div>
    </div>

    <!-- 身份证登录时，个人信息确认弹窗 -->
    <van-dialog class="PerInfoConfirmDia"
                v-model="showPersonalInfo"
                title="个人信息确认"
                show-cancel-button
                cancel-button-text="返回"
                confirm-button-color="#247dff"
                @confirm="confirmPerDia"
                @cancel="cancelPerDia">
      <van-cell-group inset>
        <van-field v-model="IDCard"
                   label="身份证号码"
                   readonly />
        <van-field v-model="perName"
                   label="姓名"
                   readonly />
        <van-field v-model="perSex"
                   label="性别"
                   readonly />
      </van-cell-group>
    </van-dialog>

    <!-- 隐私政策弹窗 -->
    <van-dialog class="PrivacyPolicyDia"
                v-model="showPrivacyPolicy"
                show-cancel-button
                :cancel-button-text="PrivacyTimeOut>0?`同意（${PrivacyTimeOut}S）`:'同意'"
                cancel-button-color="#247dff"
                confirm-button-text="不同意"
                :before-close="beforeClosePrivacy">
      <div class="Privacy_content">
        <iframe id="iframe"
                :src="user_agreement_url"
                style="height:calc(100% - 20px); width: 100%;margin-top: 15px; "
                frameborder="0"></iframe>
        <!-- <div class="Privacy_details"
        v-html="user_agreement_memo"></div>-->
      </div>
    </van-dialog>

    <van-popup round
               :closeable="true"
               v-model="showPrivacyPop"
               style=" width: 80vw; height: 80vh; padding: 20px;">
      <!-- <div style="    padding-top: 0;
    height: 45px; 
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-weight: bold;
      font-size: 0.53333rem;">{{user_agreement_title}}</div>-->
      <iframe id="iframe"
              :src="user_agreement_url"
              style="height:calc(100% - 100px); width: 100%; margin-top: 20px;"
              frameborder="0"></iframe>
      <div style=" width: 80%;
    height: 45px; 
    margin: 20px auto 0;
    background-color: #247dff;
    border-radius: 0.5vw;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4.8vw;
    letter-spacing: 0.267vw;
    color: #ffffff;
    opacity: 0.4;"
           @click="showPrivacyPop = false">确认</div>
      <!-- style="height: calc(100% - 50px)" width="100%" -->
    </van-popup>
  </div>
</template>

<script>
import { Notify, Dialog } from 'vant'
import {
  checkWXPreInputStatus,
  checkWxRsInputStatus,
  getWxApiToken,
  checkPreLoginByIdCardNum240,
  checkPreLoginByIdCardNum304,
  checkWxRsInputStatus_Comm,
  getSmsCode,
  getUserDataAgreeInfo,
  getQsTemplateOptionList_stationid,
  checkScanEntryBeforeLogin
} from '@/request/api.js'
import { IdCodeValid } from '@/utils/index.js'
import { allClose } from '@/utils'
import showAgreeMemo from './showAgreeMemo'
// import slide from './slide.vue'
import dragVerify from '../components/dragVerify.vue'
export default {
  components: {
    dragVerify,
    showAgreeMemo
    // slide
  },
  data () {
    let user_agreement_url =
      window.user_agreement_url ||
      'https://v8.hyclound.cn:8080/useragreement/index.html' // 协议链接页面
    let user_agreement_memo =
      window.user_agreement_memo ||
      '为了更好的保障你的权益，我们根据现行规定对个人信息保护相关内容进行了更新（详见<a href="' +
      user_agreement_url +
      '">《个人资料搜集、处理及利用告知书》</a>）。请您在个资录入前务必仔细阅读，如您不同意我们停止搜集你的相关个人信息。' //协议弹窗内容
    return {
      radio: null,
      screenHeight: document.documentElement.clientHeight, //屏幕高度
      h: document.documentElement.clientHeight,
      showFooter: true,
      timer: null,
      sfz: '',
      mode: true,
      isPassing2: false,
      filled: false,
      tel: '',
      code: '',
      showGetCode: false, // 显示获取验证码
      countDown: 0, // 验证码倒计时
      key: '', // 验证码绑定的key
      autoid: this.$route.query.autoid || '',
      tj_empid: this.$route.query.tj_empid || '',
      module: this.$route.query.module || '240',
      restype: this.$route.query.restype || '',
      zpacid: this.$route.query.zpacid || '',
      loading: false,
      UseSlideCheck: window.UseSlideCheck || 0, //是否启用滑动验证：1表示启用,0表示不启用
      drag_width: 300,
      drag_height: 45,
      errMsg: '', // 手机号验证错误消息
      seStaList: ['304', '317', '319'],
      agree: true, // 是否同意《用户数据采集安全协议说明》
      useagree: false,
      agreememo: '',
      showag: false,
      stationid: this.$route.query.stationid || '',
      checkEmpIdCardInfo: false, // 6.	扫码登录后弹出个人信息确认窗,体针对用身份证号码登录的模式（不限模块号）
      showPersonalInfo: false, // 身份证登录时，是否弹出个人信息确认弹窗
      IDCard: '',
      perName: '',
      perSex: '',
      result: {},
      showKeyboard: false, // 身份证键盘
      pageshow: window.pageshow, // 配置文件是否启用分页
      autoPost: 0, // 点击下一步或上一步（或左边切换时）是否启用自动保存，1保存，0不保存
      showPrivacyPolicy: false, // 用户协议弹窗
      show_user_agreement: window.show_user_agreement || 0, //登录时是否显示用户协议弹窗
      user_agreement_title: window.user_agreement_title || '用户隐私策略声明', //协议弹窗标题
      user_agreement_memo, //协议弹窗内容
      user_agreement_url, // 协议链接页面
      showLogincont: true, // 显示登陆主体
      user_agreement_timeout: window.user_agreement_timeout || 30, // 协议弹窗倒计时
      PrivacyTimeOut: '',
      PrivacyTimer: null,
      showPrivacyPop: false,
      show_sms_code: window.show_sms_code || 0, // 手机登录时是否显示短信验证码
      test_before_post: true, // 默认提交前填写问卷
    }
  },
  computed: {
    all () {
      const { tel, code, isPassing2, mode, sfz } = this
      return { tel, code, isPassing2, mode, sfz }
    },
    canSubmit () {
      let resu = false
      if (this.mode)      {
        //手机号码登录
        resu =
          this.tel !== '' &&
          (!this.showPrivacyPolicy || (this.showPrivacyPolicy && this.agree)) &&
          (this.show_sms_code == 0 ||
            (this.show_sms_code == 1 &&
              this.code !== '' &&
              ((this.UseSlideCheck == 1 && this.isPassing2) ||
                (this.UseSlideCheck == 0 && !this.isPassing2))))
      } else      {
        resu =
          this.sfz !== '' &&
          ((this.UseSlideCheck == 1 && this.isPassing2) ||
            (this.UseSlideCheck == 0 && !this.isPassing2))
      }
      return resu
    }
  },

  watch: {
    tel (n) {
      if (/^1[3456789]\d{9}$/.test(n) || n == '')      {
        this.errMsg = ''
      } else      {
        this.errMsg = '手机号格式错误'
      }
    },
    all: {
      handler (n) {
        // 电话号码验证
        this.showGetCode = this.telTest(this.tel)
        // if (
        //   (this.tel !== "" &&
        //     this.code !== "" &&
        //     this.isPassing2 &&
        //     this.mode) ||
        //   (this.sfz !== "" && this.mode == false)
        // )
        if (this.mode)        {
          //手机号码登录
          if (
            this.tel !== '' &&
            this.code !== '' &&
            ((this.UseSlideCheck == 1 && this.isPassing2) ||
              (this.UseSlideCheck == 0 && !this.isPassing2))
          )          {
            this.filled = true
          } else          {
            this.filled = false
          }
        } // 身份证登录
        else        {
          if (
            this.sfz !== '' &&
            ((this.UseSlideCheck == 1 && this.isPassing2) ||
              (this.UseSlideCheck == 0 && !this.isPassing2))
          )          {
            this.filled = true
          } else          {
            this.filled = false
          }
        }
      },
      deep: true,
      immediate: true
    }
    // screenHeight: function () {
    //   //监听屏幕高度变化
    //   let height = document.body.clientHeight
    //   if (height < this.h)
    //   {
    //     this.showFooter = false
    //   } else
    //   {
    //     if (this.module != 304)
    //     {
    //       this.showFooter = true
    //     }
    //   }
    // }
  },
  mounted () {
    var _this = this
    window.onresize = function () {
      // 定义窗口大小变更通知事件
      _this.screenHeight = document.documentElement.clientHeight //窗口高度
    }
    // if (this.show_user_agreement == 1)
    // {
    //   //给a标签添加的点击事件并阻止href跳转
    //   const licka = document.querySelector('.Privacy_details').querySelector('a')
    //   if (licka)
    //   {
    //     let this_ = this
    //     licka.href = "javascript:;"
    //     licka.addEventListener("click", function () {
    //       this_.showPrivacyPop = true
    //     })
    //   }
    // }
  },
  created () {
    // 如果启用登录时是否显示用户协议弹窗则弹窗
    this.show_user_agreement = window.show_user_agreement || 0
    if (this.show_user_agreement == 1)    {
      this.showPrivacyPolicy = true
      this.getTimeCount()
      // 登陆主体不加载
      this.showLogincont = false
    } else    {
      this.showPrivacyPolicy = false
    }

    this.pageshow = window.pageshow || 0
    // 判断各模块的登录控制
    if (this.module == 240)    {
      const m240C = window.m240 ? window.m240.canChangeLoginType : ''
      const m240D = window.m240 ? window.m240.defaultLoginType : ''
      if (m240C == 1)      {
        this.showFooter = true
      } else      {
        this.showFooter = false
      }
      if (m240D == 2)      {
        this.mode = false
      } else      {
        this.mode = true
      }
      const m240Card = window.m240 ? window.m240.checkEmpIdCardInfo : ''
      if (m240Card == 1)      {
        this.checkEmpIdCardInfo = true
      } else      {
        this.checkEmpIdCardInfo = false
      }
      this.autoPost = window.m240 ? window.m240.autoPost : 0
    } else if (this.module == 304)    {
      const m304C = window.m304 ? window.m304.canChangeLoginType : ''
      const m304D = window.m304 ? window.m304.defaultLoginType : ''
      if (m304C == 1)      {
        this.showFooter = true
      } else      {
        this.showFooter = false
      }
      if (m304D == 2)      {
        this.mode = false
      } else      {
        this.mode = true
      }
      const m304Card = window.m304 ? window.m304.checkEmpIdCardInfo : ''
      if (m304Card == 1)      {
        this.checkEmpIdCardInfo = true
      } else      {
        this.checkEmpIdCardInfo = false
      }
      this.autoPost = window.m304 ? window.m304.autoPost : 0

      const test_before_post = window.m304 ? window.m304.test_before_post : 1
      if (test_before_post == 1)
      {
        this.test_before_post = true
      } else
      {
        this.test_before_post = false
      }
    } else if (this.module == 319)    {
      const m319C = window.m319 ? window.m319.canChangeLoginType : ''
      const m319D = window.m319 ? window.m319.defaultLoginType : ''
      if (m319C == 1)      {
        this.showFooter = true
      } else      {
        this.showFooter = false
      }
      if (m319D == 2)      {
        this.mode = false
      } else      {
        this.mode = true
      }
      const m319Card = window.m319 ? window.m319.checkEmpIdCardInfo : ''
      if (m319Card == 1)      {
        this.checkEmpIdCardInfo = true
      } else      {
        this.checkEmpIdCardInfo = false
      }
      this.autoPost = window.m319 ? window.m319.autoPost : 0
    } else if (this.module == 317)    {
      const m317C = window.m317 ? window.m317.canChangeLoginType : ''
      const m317D = window.m317 ? window.m317.defaultLoginType : ''
      if (m317C == 1)      {
        this.showFooter = true
      } else      {
        this.showFooter = false
      }
      if (m317D == 2)      {
        this.mode = false
      } else      {
        this.mode = true
      }
      const m317Card = window.m317 ? window.m317.checkEmpIdCardInfo : ''
      if (m317Card == 1)      {
        this.checkEmpIdCardInfo = true
      } else      {
        this.checkEmpIdCardInfo = false
      }
      this.autoPost = window.m317 ? window.m317.autoPost : 0
    } else    {
      const mcommC = window.comm ? window.comm.canChangeLoginType : ''
      const mcommD = window.comm ? window.comm.defaultLoginType : ''
      if (mcommC == 1)      {
        this.showFooter = true
      } else      {
        this.showFooter = false
      }
      if (mcommD == 2)      {
        this.mode = false
      } else      {
        this.mode = true
      }
      const mcommCard = window.comm ? window.comm.checkEmpIdCardInfo : ''
      if (mcommCard == 1)      {
        this.checkEmpIdCardInfo = true
      } else      {
        this.checkEmpIdCardInfo = false
      }
      this.autoPost = window.comm ? window.comm.autoPost : 0
    }

    getWxApiToken().then(res => {
      sessionStorage.setItem('token', res)
      getUserDataAgreeInfo({
        moduleno: this.module,
        username: 'admin'
      }).then(r => {
        sessionStorage.setItem(
          'usedicfilename',
          r.data[0].usedicfilename.toString()
        )
        sessionStorage.setItem('usepresign', r.data[0].usepresign.toString())
        this.useagree = r.data[0].useagree
        this.agree = !r.data[0].useagree
        this.agreememo = r.data[0].agreememo
      })
    })
    this.drag_width = window.screen.width * 0.84
    this.drag_height = window.screen.width * 0.12533

    if (this.autoid != '')    {
      checkWxRsInputStatus_Comm({
        iflag: 0,
        inputcode: this.tel
      }).then(res => {
        // 预入职
        let redirect = '/seForm?module=' + this.module
        const r =
          redirect +
          '&tel=' +
          this.tel +
          '&attachfilepath=' +
          res.data[0].attachfilepath +
          '&autoid=' +
          this.autoid +
          '&mode=' +
          this.mode +
          '&restype=' +
          this.restype
        this.$router.push(r)
      })
    }
  },
  methods: {
    // 隐私弹窗同意倒计时
    getTimeCount () {
      const TIME_COUNT = this.user_agreement_timeout
      if (!this.PrivacyTimer)      {
        this.PrivacyTimeOut = TIME_COUNT
        this.PrivacyTimer = setInterval(() => {
          if (this.PrivacyTimeOut > 0 && this.PrivacyTimeOut <= TIME_COUNT)          {
            this.PrivacyTimeOut--
          } else          {
            clearInterval(this.PrivacyTimer)
            this.PrivacyTimer = null
          }
        }, 1000)
      }
    },
    // 隐私弹窗关闭回调
    beforeClosePrivacy (action, done) {
      if (action == 'confirm')      {
        done()
        allClose()
      } else      {
        if (this.PrivacyTimeOut > 0)        {
          done(false)
        } else        {
          // 关闭弹窗
          this.showPrivacyPolicy = false
          // 登陆主体加载
          this.showLogincont = true
          done()
        }
      }
    },
    // 身份证键盘关闭
    KeyboardBlur () {
      // 身份证验证
      if (this.sfz)      {
        let sfzTest = IdCodeValid(this.sfz)
        if (sfzTest.pass)        {
          this.showKeyboard = false
        } else        {
          // 否则就是身份证格式错误
          Notify({ type: 'danger', message: sfzTest.msg })
        }
      } else      {
        this.showKeyboard = false
      }
    },
    // 身份确认
    confirmPerDia () {
      this.showPersonalInfo = false
      this.nextOperation(this.result)
    },
    cancelPerDia () {
      this.$router.go(0)
    },
    // 身份证登录时，身份确认弹窗确认后的操作
    nextOperation (result) {
      if (this.module == 240)      {
        this.loading = true
        // 预入职
        let redirect = '/seForm?module=' + this.module
        const r =
          redirect +
          '&tel=' +
          this.tel +
          '&attachfilepath=' +
          result.attachfilepath +
          '&autoid=' +
          result.autoid +
          '&mode=' +
          this.mode
        this.$router.push(r)
      } else if (301 <= parseInt(this.module) && parseInt(this.module) <= 399)      {
        // 如果参数带有stationid的则跳过岗位选择
        if (this.stationid)        {
          const station = {
            staname: '',
            stationid: this.stationid
          }
          sessionStorage.setItem('station', JSON.stringify(station))
          // 检查是否做过问卷
          if (result.istest)          {
            // 表示做过问卷直接进入
            localStorage.setItem('questionData', JSON.stringify([]))
            this.loading = true
            // 预入职(有身份证存在的直接跳到填写简历信息页面)
            let redirect =
              '/seForm?module=' + this.module + '&zpacid=' + this.zpacid
            const r =
              redirect +
              '&tel=' +
              this.tel +
              '&attachfilepath=' +
              result.attachfilepath +
              '&autoid=' +
              result.autoid +
              '&mode=' +
              this.mode +
              '&tj_empid=' +
              this.tj_empid
            this.$router.push(r)
          } else          {
            // 没有做过问卷则查询问卷
            //投递简历之前应该判断是否有问卷调查的数据，如果有则需要填完调查表再进行跳转，如果没有则可以直接跳转
            getQsTemplateOptionList_stationid({
              stationid: this.stationid
            }).then(res => {
              if (res.baseinfo.length == 0 && res.data.length == 0 || this.test_before_post == false)              {
                // 表示没有问卷数据
                localStorage.setItem('questionData', JSON.stringify([]))
                this.loading = true
                // 预入职(有身份证存在的直接跳到填写简历信息页面)
                let redirect =
                  '/seForm?module=' + this.module + '&zpacid=' + this.zpacid
                const r =
                  redirect +
                  '&tel=' +
                  this.tel +
                  '&attachfilepath=' +
                  result.attachfilepath +
                  '&autoid=' +
                  result.autoid +
                  '&mode=' +
                  this.mode +
                  '&tj_empid=' +
                  this.tj_empid
                this.$router.push(r)
              } else              {
                // 表示有问卷数据，需要跳转到问卷页面
                let qd = {
                  baseinfo: [],
                  data: []
                }
                qd.baseinfo = res.baseinfo
                qd.data = res.data
                localStorage.setItem('questionData', JSON.stringify(qd))
                // 跳转到问卷页面
                this.$router.push({
                  path: '/questionnaire',
                  query: {
                    module: this.module,
                    restype: this.restype,
                    tel: this.tel,
                    tj_empid: this.tj_empid,
                    zpacid: this.zpacid,
                    directJump: true,
                    istest: result.istest,
                    attachfilepath: result.attachfilepath,
                    autoid: result.autoid
                  }
                })
              }
            })
          }
        } else        {
          // 没有岗位则要跳转至岗位选择
          let redirect =
            '/seStaList?module=' + this.module + '&zpacid=' + this.zpacid
          const r =
            redirect +
            '&tel=' +
            this.tel +
            '&restype=' +
            this.restype +
            '&tj_empid=' +
            this.tj_empid +
            '&istest=' +
            result.istest +
            '&attachfilepath=' +
            result.attachfilepath +
            '&autoid=' +
            result.autoid
          this.$router.push(r)
        }
      } else      {
        this.loading = true
        // 预入职
        let redirect = '/seForm?module=' + this.module
        const r =
          redirect +
          '&tel=' +
          this.tel +
          '&attachfilepath=' +
          result.attachfilepath +
          '&autoid=' +
          result.autoid +
          '&mode=' +
          this.mode
        this.$router.push(r)
      }
    },

    changeMode () {
      this.mode = !this.mode
      this.isPassing2 = false
      this.$refs.dragVerify.reset()
      clearInterval(this.timer)
      this.countDown = 0
    },
    // 通过
    pass () {
      // console.log(this.isPassing2, "isPassing2");
    },
    // 电话号码验证
    telTest (tel) {
      return /^1[3456789]\d{9}$/.test(tel)
    },

    // 获取验证码
    getCode () {
      getSmsCode({
        mobilephone: this.tel
      }).then(res => {
        if (res.iserror == 0)        {
          Notify({ type: 'success', message: '发送验证码成功' })
          this.code = ''
          this.key = res.topvalue
          if (res.topvalue == 1234)          {
            this.code = 1234
          }
        } else if (res.iserror == 1)        {
          Notify({
            type: 'danger',
            message: '获取验证码失败！原因：' + res.errormsg
          })
        }
      })
      this.countDown = 59
      this.timer = setInterval(() => {
        if (this.countDown > 0)        {
          this.countDown--
        } else        {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    // 确定
    check () {
      // if (!this.filled) return
      if (!this.canSubmit) return
      // 登录提醒
      checkScanEntryBeforeLogin({
        telephone: this.tel,
        idcardnum: this.sfz,
        moduleno: this.module
      }).then(res => {
        if (res.data[0].info)        {
          if (res.data[0].cansave)          {
            Dialog.confirm({
              title: '提示',
              message: res.data[0].info
            })
              .then(() => {
                this.SignIn()
              })
              .catch(() => {
                // on cancel
              })
          } else          {
            Dialog.alert({
              title: '提示',
              message: res.data[0].info
            }).then(() => {
              // on close
            })
          }
        } else        {
          this.SignIn()
        }
      })
    },
    // 登录
    SignIn () {
      if (this.mode)      {
        // 手机号码登录
        // 验证码输入不一致
        if (
          this.code != this.key &&
          (this.show_sms_code == 1 || this.show_sms_code == '1')
        )        {
          Notify({ type: 'danger', message: '验证码输入有误' })
          return
        }
        if (!this.agree && this.showPrivacyPolicy)        {
          Notify({
            type: 'danger',
            message: '请阅读并同意《' + this.user_agreement_title + '》'
          })
          return
        }
        let userName = 'system_wx'
        if (this.module == 240)        {
          userName = 'system_wx_' + this.module
          if (this.restype)          {
            // 区域招聘
            userName = 'system_' + this.restype
          }
        } else if (this.module == 317)        {
          // this.formstr.crman = 'system_lt'
          userName = 'system_lt'
        } else if (this.module == 319)        {
          // this.formstr.crman = 'system_xy'
          userName = 'system_xy'
        } else if (this.module == 304)        {
          // this.formstr.crman = 'system_wx'
          userName = 'system_wx'
        } else if (this.module == 322)        {
          // this.formstr.crman = 'system_wx'
          userName = 'system_pq'
        } else        {
          // this.formstr.crman = 'system_wx'
          userName = 'system_wx'
        }
        this.loading = true
        //return
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.module === '240')            {
              checkWXPreInputStatus({
                telephone: this.tel,
                pageshow: this.pageshow,
                autoPost: this.autoPost,
                crman: userName
              }).then(res => {
                // 预入职
                let redirect = '/seForm?module=' + this.module
                const r =
                  redirect +
                  '&tel=' +
                  this.tel +
                  '&attachfilepath=' +
                  res.data[0].attachfilepath +
                  '&autoid=' +
                  res.data[0].autoid +
                  '&mode=' +
                  this.mode +
                  '&restype=' +
                  this.restype
                this.$router.push(r)
              })
            }
            // else if (this.seStaList.includes(this.module))
            else if (
              301 <= parseInt(this.module) &&
              parseInt(this.module) <= 399
            )            {
              checkWxRsInputStatus({
                telephone: this.tel,
                pageshow: this.pageshow,
                autoPost: this.autoPost,
                crman: userName
              }).then(res => {
                // 如果参数带有stationid的则跳过岗位选择
                if (this.stationid)                {
                  //投递简历之前应该判断是否有问卷调查的数据，如果有则需要填完调查表再进行跳转，如果没有则可以直接跳转
                  const station = {
                    staname: '',
                    stationid: this.stationid
                  }
                  sessionStorage.setItem('station', JSON.stringify(station))
                  // 检查是否做过问卷
                  if (res.data[0].istest)                  {
                    localStorage.setItem('questionData', JSON.stringify([]))
                    // 简历投递
                    let redirect =
                      '/seForm?module=' + this.module + '&zpacid=' + this.zpacid
                    const r =
                      redirect +
                      '&tel=' +
                      this.tel +
                      '&attachfilepath=' +
                      res.data[0].attachfilepath +
                      '&autoid=' +
                      res.data[0].autoid +
                      '&restype=' +
                      this.restype +
                      '&tj_empid=' +
                      this.tj_empid
                    this.$router.push(r)
                  } else                  {
                    // 没有做过就查询有没有问卷
                    getQsTemplateOptionList_stationid({
                      stationid: this.stationid
                    }).then(re => {
                      if (re.baseinfo.length == 0 && re.data.length == 0 || this.test_before_post == false)                      {
                        // 表示没有问卷数据
                        localStorage.setItem('questionData', JSON.stringify([]))
                        // 简历投递
                        let redirect =
                          '/seForm?module=' +
                          this.module +
                          '&zpacid=' +
                          this.zpacid
                        const r =
                          redirect +
                          '&tel=' +
                          this.tel +
                          '&attachfilepath=' +
                          res.data[0].attachfilepath +
                          '&autoid=' +
                          res.data[0].autoid +
                          '&restype=' +
                          this.restype +
                          '&tj_empid=' +
                          this.tj_empid
                        this.$router.push(r)
                      } else                      {
                        // 表示有问卷数据，需要跳转到问卷页面
                        let qd = {
                          baseinfo: [],
                          data: []
                        }
                        qd.baseinfo = re.baseinfo
                        qd.data = re.data
                        localStorage.setItem('questionData', JSON.stringify(qd))
                        // 跳转到问卷页面
                        this.$router.push({
                          path: '/questionnaire',
                          query: {
                            module: this.module,
                            restype: this.restype,
                            tel: this.tel,
                            tj_empid: this.tj_empid,
                            directJump: true,
                            istest: res.data[0].istest,
                            attachfilepath: res.data[0].attachfilepath,
                            zpacid: this.zpacid,
                            autoid: res.data[0].autoid
                          }
                        })
                      }
                    })
                  }
                } else                {
                  // 没有岗位则要跳转至岗位选择
                  let redirect =
                    '/seStaList?module=' +
                    this.module +
                    '&zpacid=' +
                    this.zpacid
                  const r =
                    redirect +
                    '&tel=' +
                    this.tel +
                    '&restype=' +
                    this.restype +
                    '&tj_empid=' +
                    this.tj_empid +
                    '&istest=' +
                    res.data[0].istest +
                    '&attachfilepath=' +
                    res.data[0].attachfilepath +
                    '&autoid=' +
                    res.data[0].autoid
                  this.$router.push(r)
                }
              })
            } else            {
              // 其他模块
              checkWxRsInputStatus_Comm({
                iflag: 0,
                inputcode: this.tel
              }).then(res => {
                // 预入职
                let redirect = '/seForm?module=' + this.module
                const r =
                  redirect +
                  '&tel=' +
                  this.tel +
                  '&attachfilepath=' +
                  res.data[0].attachfilepath +
                  '&autoid=' +
                  res.data[0].autoid +
                  '&mode=' +
                  this.mode +
                  '&restype=' +
                  this.restype
                this.$router.push(r)
              })
            }
          }, 100)
        })
      } else      {
        // 身份证验证
        let sfzTest = IdCodeValid(this.sfz)
        if (sfzTest.pass)        {
          if (this.module == 240)          {
            checkPreLoginByIdCardNum240({ idcardnum: this.sfz }).then(res => {
              if (res.data[0].autoid == null || res.data[0].autoid <= 0)              {
                Notify({
                  type: 'danger',
                  message: '未找到该身份证号码相关信息'
                })
              } else              {
                if (this.checkEmpIdCardInfo)                {
                  // 弹窗
                  this.showPersonalInfo = true
                  this.result = res.data[0]
                  this.IDCard = res.data[0].idcardnum
                  this.perName = res.data[0].empname
                  this.perSex = res.data[0].sex
                } else                {
                  this.nextOperation(res.data[0])
                }
              }
            })
          } else if (
            301 <= parseInt(this.module) &&
            parseInt(this.module) <= 399
          )          {
            // 简历投递
            checkPreLoginByIdCardNum304({ idcardnum: this.sfz }).then(res => {
              if (res.data[0].autoid == null || res.data[0].autoid <= 0)              {
                Notify({
                  type: 'danger',
                  message: '未找到该身份证号码相关信息'
                })
              } else              {
                if (this.checkEmpIdCardInfo)                {
                  // 弹窗
                  this.showPersonalInfo = true
                  this.result = res.data[0]
                  this.IDCard = res.data[0].idcardnum
                  this.perName = res.data[0].empname
                  this.perSex = res.data[0].sex
                } else                {
                  this.nextOperation(res.data[0])
                }
              }
            })
          } else          {
            // 其他模块
            checkWxRsInputStatus_Comm({
              iflag: 1,
              inputcode: this.sfz
            }).then(res => {
              if (res.data[0].autoid == null)              {
                Notify({
                  type: 'danger',
                  message: '未找到该身份证号码相关信息'
                })
              } else              {
                if (this.checkEmpIdCardInfo)                {
                  // 弹窗
                  this.showPersonalInfo = true
                  this.result = res.data[0]
                  this.IDCard = res.data[0].idcardnum
                  this.perName = res.data[0].empname
                  this.perSex = res.data[0].sex
                } else                {
                  this.nextOperation(res.data[0])
                }
              }
            })
          }
        } else        {
          // 否则就是身份证格式错误
          Notify({ type: 'danger', message: sfzTest.msg })
        }
      }
    },
    showAgreeMemo () {
      sessionStorage.setItem('agreememo', this.agreememo)
      this.$router.push('/showAgreeMemo')
    }
  }
}
</script>

<style scoped lang="less">
.PrivacyPolicyDia {
  /deep/.van-dialog__header {
    padding-top: 0;
    height: 110px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-weight: bold;
    font-size: 40px;
  }
  /deep/.van-dialog__content {
    padding: 0 40px;
    .Privacy_content {
      // max-height: 65vh;
      height: 70vh;
      overflow-y: auto;
      color: #646566;
    }
  }
}

.PerInfoConfirmDia {
  /deep/.van-dialog__header {
    padding-top: 0;
    height: 110px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-weight: 500;
    font-size: 40px;
  }
  .van-dialog__content {
    .van-cell-group {
      padding: 30px;
    }
  }
}
.page {
  height: 100vh;
  overflow-y: scroll;
  .loading {
    position: absolute;
    padding-top: 75%;
    padding-left: 45%;
    z-index: 1111;
  }
  .footer {
    position: fixed;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    span {
      color: red;
      font-size: 30px;
    }
  }
  .footer2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    .van-checkbox {
      font-size: 30px;
      span {
        color: red;
      }
    }
    .van-popup {
      width: 80%;
      height: 80%;
      overflow: auto;
      padding: 80px 20px 20px;
    }
  }
  .dragVerify {
    padding-top: 32px;
    padding-bottom: 16px;
    display: flex;
    justify-content: center;
    .drag {
      --width: 134px !important;
      --pwidth: -134px !important;
      // background: red!important;
      /deep/.dv_text {
        width: 100%;
        color: red;
      }
    }
    .drag_verify {
      /deep/.dv_handler {
        display: flex;
        justify-content: center;
        align-items: center;
        .fa {
          margin-top: unset;
        }
      }
    }
  }
  .register_title {
    font-size: 5vw;
    color: #303133;
    padding: 2vw 0;
    text-align: center;
    // border-bottom: 0.013333rem solid #eee;
    border-bottom: 0.13333vw solid #bababc;
  }
  .op {
    opacity: 1 !important;
  }
  .Sed {
    width: 84vw;
    height: 12.533vw;
    /* margin: 0 auto; */
    margin: 5vw auto;
    background-color: #247dff;
    border-radius: 0.5vw;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4.8vw;
    letter-spacing: 0.267vw;
    color: #ffffff;
    opacity: 0.8 !important;
  }
  .input_box {
    width: 84vw;
    margin: 0 auto;
    margin-top: 13.333vw;
    .icon {
      width: 106px;
      height: 106px;
      margin: 0 auto;
      background: url("~@/assets/img/login.png") no-repeat;
      background-size: 100% 100%;
      // text-align: center;
      // .svg-icon {
      //   width: 27%;
      //   height: 106px;
      // }
    }
    .input_box_xia {
      height: 11.333vw;
      // border-bottom: 1px solid #edeff2;
      border-bottom: 1px solid #70b6ff;
      margin-top: 8vw;
      display: flex;
      justify-content: space-between;
      .code_gain {
        width: 35vw;
        height: 8vw;
        background-color: #edeff2;
        border-radius: 0.5vw;
        font-size: 3.467vw;
        color: #909399;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .code_gain-on {
        background-color: #008eed;
        color: #ffffff;
      }

      /deep/.van-cell {
        border-radius: 0.5vw;
        .van-field__label {
          width: 5.2em;
        }
        .van-field__value {
          .van-field__error-message {
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
    }
  }
}
</style>
